import React from 'react';

const StoryShare = () => null;

export default StoryShare;
